var React = require('react');

function Circle (props) {
    return React.createElement("svg",props,[React.createElement("defs",{"key":0},React.createElement("style",null,".a{fill:#fff;}")),React.createElement("path",{"className":"a","d":"M427.152,248.191a78.961,78.961,0,1,1-78.962-78.962A79.05,79.05,0,0,1,427.152,248.191Zm-157.318,0a78.357,78.357,0,1,0,78.356-78.359A78.447,78.447,0,0,0,269.834,248.191Z","transform":"translate(-269.231 -169.229)","key":1})]);
}

Circle.defaultProps = {"width":"157.921","height":"157.921","viewBox":"0 0 157.921 157.921"};

module.exports = Circle;

Circle.default = Circle;
